<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" label-width="100px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="8">
              <el-form-item label="查询方式" prop="queryMode">
                <el-radio-group v-model="queryParams.queryMode">
                  <el-radio :label="'single'">单月</el-radio>
                  <el-radio :label="'range'">区间</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="queryParams.queryMode === 'single'">
              <el-form-item label="月份" prop="yearMonth">
                <el-date-picker v-model="queryParams.yearMonth" type="month" placeholder="请选择月份" value-format="yyyy-MM" style="width: 100%;" @change="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-else>
              <el-form-item label="月份区间" prop="yearMonthRange">
                <el-date-picker v-model="queryParams.yearMonthRange" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyy-MM" style="width: 100%;"
                                @change="handleSearch" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleReset="handleReset" @exportToExcel="exportToExcel" @openBaseDialog="openBaseDialog" />
            <!-- <el-button type="primary" size="small" style="margin-left: 10px;" @click="openBaseDialog">保底绩效管理</el-button> -->
          </div>

          <!-- 数据表格（多级表头） -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'center', borderColor: '#CCC' }"
                    v-loading="loading" show-summary :summary-method="getSummaries">
            <el-table-column type="index" label="序号" width="60" align="center" fixed="left" />
            <!-- 检测人员 -->
            <el-table-column label="检测人员" align="left" prop="employeeName" min-width="120" show-overflow-tooltip fixed="left" />
            <!-- 自动扶梯 -->
            <el-table-column label="自动扶梯" align="center">
              <el-table-column label="扶手梯台数" align="right" prop="autoEscalatorCount" min-width="120" show-overflow-tooltip />
              <el-table-column label="扶手梯单价" align="right" prop="autoEscalatorRate" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.autoEscalatorRate) }}
                </template>
              </el-table-column>
              <el-table-column label="扶手梯绩效" align="right" prop="autoEscalatorAmount" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.autoEscalatorAmount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 自动人行道 -->
            <el-table-column label="自动人行道" align="center">
              <el-table-column label="扶手梯台数" align="center" prop="autoWalkwayCount" min-width="120" show-overflow-tooltip />
              <el-table-column label="扶手梯单价" align="center" prop="autoWalkwayRate" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.autoWalkwayRate) }}
                </template>
              </el-table-column>
              <el-table-column label="扶手梯绩效" align="center" prop="autoWalkwayAmount" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.autoWalkwayAmount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 杂物梯 -->
            <el-table-column label="杂物梯" align="center">
              <el-table-column label="杂物梯台数" align="center" prop="freightLiftCount" min-width="120" show-overflow-tooltip />
              <el-table-column label="杂物梯单价" align="center" prop="freightLiftRate" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.freightLiftRate) }}
                </template>
              </el-table-column>
              <el-table-column label="杂物梯绩效" align="center" prop="freightLiftAmount" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.freightLiftAmount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 直梯≤10型 -->
            <el-table-column label="直梯≤10型" align="center">
              <el-table-column label="直梯≤10型台数" align="center" prop="elevator10Count" min-width="120" show-overflow-tooltip />
              <el-table-column label="直梯≤10型单价" align="center" prop="elevator10Rate" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.elevator10Rate) }}
                </template>
              </el-table-column>
              <el-table-column label="直梯≤10型绩效" align="center" prop="elevator10Amount" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.elevator10Amount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 直梯>10型 -->
            <el-table-column label="直梯>10型" align="center">
              <el-table-column label="直梯>10型台数" align="center" prop="elevatorGt10Count" min-width="120" show-overflow-tooltip />
              <el-table-column label="直梯>10型单价" align="center" prop="elevatorGt10Rate" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.elevatorGt10Rate) }}
                </template>
              </el-table-column>
              <el-table-column label="直梯>10型绩效" align="center" prop="elevatorGt10Amount" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.elevatorGt10Amount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 第三方评估 -->
            <el-table-column label="第三方评估" align="center">
              <el-table-column label="评估台数" align="center" prop="thirdPartyCount" min-width="120" show-overflow-tooltip />
              <el-table-column label="评估绩效" align="center" prop="thirdPartyAmount" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.thirdPartyAmount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 审核报告 -->
            <el-table-column label="审核报告" align="center">
              <el-table-column label="审核台数" align="center" prop="auditReportCount" min-width="120" show-overflow-tooltip />
              <el-table-column label="审核绩效" align="center" prop="auditReportAmount" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatAmount(scope.row.auditReportAmount) }}
                </template>
              </el-table-column>
            </el-table-column>

            <!-- 保底绩效 -->
            <el-table-column label="保底绩效（元）" align="center" prop="basePerformance" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatAmount(scope.row.basePerformance) }}
              </template>
            </el-table-column>

            <!-- 当前绩效 -->
            <el-table-column label="当前绩效（元）" align="center" prop="currentPerformance" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatAmount(scope.row.currentPerformance) }}
              </template>
            </el-table-column>

            <!-- 合计 -->
            <el-table-column label="合计（元）" align="center" prop="totalPerformance" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatAmount(scope.row.totalPerformance) }}
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination style="margin-top: 10px; text-align: right;" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="queryParams.currPage"
                         :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </el-form>
      </el-col>
    </el-row>

    <!-- 保底绩效管理弹窗 -->
    <el-dialog title="保底绩效管理" :visible.sync="baseDialogVisible" width="1200px" append-to-body>
      <el-table :data="baseList" border style="width: 100%; margin-top: 10px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'center', borderColor: '#CCC' }" v-loading="baseDialogLoading">
        <el-table-column label="生效年月" align="center" min-width="180">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.effectiveYearMonth" type="month" placeholder="选择月份" value-format="yyyy-MM" style="width: 120px;" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="失效年月" align="center" min-width="180">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.expiryYearMonth" type="month" placeholder="选择月份" value-format="yyyy-MM" style="width: 120px;" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="保底绩效金额（元）" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.baseAmount" size="small" placeholder="请输入金额" @input="onBaseAmountInput(scope.row, 'baseAmount')" />
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" min-width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" size="small" placeholder="请输入备注" clearable />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot="header">
            <el-button type="primary" size="mini" @click="addBaseRow">新增</el-button>
          </template>
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeBaseRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer" style="text-align: right;">
        <el-button @click="baseDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBaseList">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryPerformanceStatistics,
  exportPerformanceStatistics,
  queryPerformanceBaseList,
  confirmPerformanceBaseList
} from '@/api/contract/contract'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'

export default {
  name: 'Performance',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PermissionMethodToolbar
  },
  data () {
    return {
      showSearch: true,
      loading: false,
      tableData: [],
      queryParams: {
        queryMode: 'single', // single: 单月；range: 区间
        yearMonth: '',
        yearMonthRange: [],
        confirmationStatus: 1, // 确认状态，默认值1，可根据实际需求调整
        currPage: 1,
        pageSize: 10
      },
      total: 0,
      // 保底绩效管理
      baseDialogVisible: false,
      baseDialogLoading: false,
      baseList: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 格式化金额，保留2位小数
    formatAmount (val) {
      if (val === null || val === undefined || val === '') return '0.00'
      const num = Number(val)
      return Number.isFinite(num) ? num.toFixed(2) : '0.00'
    },

    buildParams () {
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      // 单月 / 区间 查询参数
      if (this.queryParams.queryMode === 'single') {
        if (this.queryParams.yearMonth) {
          params.yearMonth = this.queryParams.yearMonth
        }
      } else if (Array.isArray(this.queryParams.yearMonthRange) && this.queryParams.yearMonthRange.length === 2) {
        const [startYearMonth, endYearMonth] = this.queryParams.yearMonthRange
        if (startYearMonth) params.startYearMonth = startYearMonth
        if (endYearMonth) params.endYearMonth = endYearMonth
      }

      // confirmationStatus 参数（预留，可根据实际需求调整）
      if (this.queryParams.confirmationStatus !== undefined && this.queryParams.confirmationStatus !== null) {
        params.confirmationStatus = this.queryParams.confirmationStatus
      }

      return params
    },

    normalizeList (res) {
      // 兼容后端返回：{ retCode:'ok', additionalData: { list/records/dataList } } 或者 additionalData 直接是数组
      if (res && res.retCode === 'ok') {
        const ad = res.additionalData
        if (Array.isArray(ad)) return ad
        if (ad && Array.isArray(ad.dataList)) return ad.dataList
        if (ad && Array.isArray(ad.records)) return ad.records
        if (ad && Array.isArray(ad.list)) return ad.list
        return []
      }

      // 兜底：直接返回数组
      if (Array.isArray(res)) return res
      if (res && Array.isArray(res.additionalData)) return res.additionalData
      return []
    },

    // 查询按钮
    handleSearch () {
      // 查询从第一页开始
      this.queryParams.currPage = 1
      this.getList()
    },

    // 重置按钮
    handleReset () {
      this.queryParams.queryMode = 'single'
      this.queryParams.yearMonth = ''
      this.queryParams.yearMonthRange = []
      this.queryParams.currPage = 1
      this.getList()
    },

    // 修改每页条数
    handleSizeChange (size) {
      this.queryParams.pageSize = size
      this.queryParams.currPage = 1
      this.getList()
    },

    // 分页切换页码
    handlePageChange (page) {
      this.queryParams.currPage = page
      this.getList()
    },

    // 列表查询
    getList () {
      this.loading = true
      const params = this.buildParams()

      queryPerformanceStatistics(params).then(res => {
        // 处理分页信息
        if (res && res.retCode === 'ok' && res.additionalData) {
          const ad = res.additionalData
          this.total = ad.total || 0
          if (ad.current !== undefined) {
            this.queryParams.currPage = ad.current
          }
          if (ad.size !== undefined) {
            this.queryParams.pageSize = ad.size
          }
        }

        const list = this.normalizeList(res) || []
        this.tableData = list
        this.loading = false
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败：' + (error.message || '未知错误'))
        this.tableData = []
        this.loading = false
      })
    },

    // 导出
    exportToExcel () {
      this.$message.success('正在导出绩效统计数据...')
      const params = this.buildParams()

      // 导出API暂时预留，等后端完成后再启用
      exportPerformanceStatistics(params).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = '绩效统计.xlsx'

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },

    // ---------- 保底绩效管理相关 ----------
    // 打开保底绩效管理弹窗
    openBaseDialog () {
      this.baseDialogVisible = true
      this.fetchBaseList()
    },

    // 查询保底绩效配置列表
    fetchBaseList () {
      this.baseDialogLoading = true
      const params = {
        currPage: 1,
        pageSize: 100
      }
      queryPerformanceBaseList(params).then(res => {
        const list = this.normalizeList(res) || []
        // 确保是可编辑的浅拷贝
        this.baseList = list.map(item => ({
          effectiveYearMonth: item.effectiveYearMonth || '',
          expiryYearMonth: item.expiryYearMonth || '',
          baseAmount: item.baseAmount,
          remark: item.remark || ''
        }))
        this.baseDialogLoading = false
      }).catch(error => {
        console.error('保底绩效配置查询失败:', error)
        this.$message.error('查询保底绩效配置失败：' + (error.message || '未知错误'))
        this.baseList = []
        this.baseDialogLoading = false
      })
    },

    // 新增一行保底绩效配置
    addBaseRow () {
      this.baseList.push({
        effectiveYearMonth: '',
        expiryYearMonth: '',
        baseAmount: '',
        remark: ''
      })
    },

    // 删除一行保底绩效配置
    removeBaseRow (index) {
      this.$confirm('确认删除该条保底绩效配置吗？', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.baseList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => { })
    },

    // 金额输入限制为非负数值
    onBaseAmountInput (row, field) {
      let val = row[field]
      if (val === null || val === undefined) {
        row[field] = ''
        return
      }
      val = String(val)
      // 只保留数字和小数点
      val = val.replace(/[^\d.]/g, '')
      // 只保留第一个小数点
      const firstDotIndex = val.indexOf('.')
      if (firstDotIndex !== -1) {
        const before = val.slice(0, firstDotIndex + 1)
        const after = val.slice(firstDotIndex + 1).replace(/\./g, '')
        val = before + after
      }
      // 转为数值并限制为非负
      const num = val === '' ? '' : Number(val)
      if (val !== '' && !Number.isFinite(num)) {
        row[field] = ''
      } else if (num < 0) {
        row[field] = '0'
      } else {
        row[field] = val
      }
    },

    // 保存保底绩效配置
    saveBaseList () {
      if (!this.baseList.length) {
        this.$message.warning('请先添加至少一条保底绩效配置')
        return
      }

      // 简单校验
      for (let i = 0; i < this.baseList.length; i++) {
        const row = this.baseList[i]
        if (!row.effectiveYearMonth) {
          this.$message.warning(`第 ${i + 1} 行的生效年月不能为空`)
          return
        }
        if (!row.expiryYearMonth) {
          this.$message.warning(`第 ${i + 1} 行的失效年月不能为空`)
          return
        }
        const amountNum = this.toNumber(row.baseAmount)
        if (amountNum <= 0) {
          this.$message.warning(`第 ${i + 1} 行的保底绩效金额必须大于 0`)
          return
        }
        // 将金额标准化为数字，避免字符串
        row.baseAmount = amountNum
      }

      confirmPerformanceBaseList(this.baseList).then(() => {
        this.$message.success('保底绩效配置保存成功')
        this.baseDialogVisible = false
        // 保存成功后，可选择重新刷新主列表
        this.getList()
      }).catch(error => {
        console.error('保底绩效配置保存失败:', error)
        this.$message.error('保存失败：' + (error.message || '未知错误'))
      })
    },

    // 数字转换工具
    toNumber (val) {
      if (val === null || val === undefined || val === '') return 0
      const n = Number(val)
      return Number.isFinite(n) ? n : 0
    },

    // el-table 合计行
    getSummaries ({ columns, data }) {
      const sums = []
      const labelProps = ['employeeName'] // 显示“合计”的字段
      const amountOrPerformanceSuffix = ['Amount', 'Performance']

      columns.forEach((column, index) => {
        const prop = column.property

        // 无prop的列
        if (!prop) {
          sums[index] = ''
          return
        }

        // 检测人员列显示"合计"
        if (labelProps.includes(prop)) {
          sums[index] = '合计'
          return
        }

        // 单价列：用“合计金额/合计台数”计算加权平均单价
        if (prop.endsWith('Rate')) {
          const base = prop.slice(0, -'Rate'.length) // 如 autoEscalator
          const amountProp = base + 'Amount'
          const countProp = base + 'Count'
          const totalAmount = (data || []).reduce((acc, row) => acc + this.toNumber(row[amountProp]), 0)
          const totalCount = (data || []).reduce((acc, row) => acc + this.toNumber(row[countProp]), 0)
          sums[index] = totalCount > 0 ? (totalAmount / totalCount).toFixed(2) : '-'
          return
        }

        // 台数字段：整数合计（*Count）
        if (prop.endsWith('Count')) {
          const total = (data || []).reduce((acc, row) => acc + this.toNumber(row[prop]), 0)
          sums[index] = String(Math.round(total))
          return
        }

        // 金额字段：保留2位小数（*Amount / *Performance）
        if (amountOrPerformanceSuffix.some(suffix => prop.endsWith(suffix))) {
          const total = (data || []).reduce((acc, row) => acc + this.toNumber(row[prop]), 0)
          sums[index] = total.toFixed(2)
          return
        }

        // 其他字段不显示合计
        sums[index] = ''
      })

      return sums
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
